.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

/* stylelint-disable */
.circular-economy {
  border: 1px solid #e7e6e6;
  display: block;
  padding: 10px;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 20px;
}

@media screen and (max-width: 979px) {
  .circular-economy {
    margin: 0 auto;
  }
}

.circular-economy .content {
  font-size: 14px;
  line-height: 1.4285714286;
}

:host(:not([dir="rtl"])) .circular-economy .content {
  padding-right: 10px;
}

:host([dir="rtl"]) .circular-economy .content {
  padding-left: 10px;
}

.circular-economy .content-container {
  padding-top: 6px;
  width: -moz-fit-content;
  width: fit-content;
}

.link {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
  display: inline-block;
  line-height: 1.1428571429;
}

.link:visited {
  color: var(--qds-theme-link-standard-visited);
}

.link:hover {
  color: var(--qds-theme-link-standard-hover);
}

.link:active {
  color: var(--qds-theme-link-standard-pressed);
}

.link:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.link:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.link[rel~=external] > .qds-external {
  display: inline-block;
}

.link:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.link[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}